import { Component } from '@angular/core';

@Component({
  selector: 'app-tags-skeleton',
  templateUrl: './tags-skeleton.component.html',
  styleUrls: ['./tags-skeleton.component.scss'],
  standalone: true
})
export class TagsSkeletonComponent {
  tags = new Array(10);
}
